import './App.css';
import PrivateRoute from "./components/PrivateComponents";
import { Route, Routes, Navigate } from "react-router-dom";
import {Dashboard} from "./components/Dashboard";
import LoginPage from "./auth/Login";

function App() {

    const token = localStorage.getItem('accessToken');
    return (
        <div className="App">
            <Routes>
                <Route
                    path="/login"
                    element={token ? <Navigate to="/" replace /> : <LoginPage />}
                />
                <Route
                    path="/"
                    element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    }
                />
            </Routes>
        </div>
    );
}

export default App;
